"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AreaSelector = void 0;

var Rect_1 = require("../Core/Rect");

var ISelectorSettings_1 = require("../Interface/ISelectorSettings");

var PointSelector_1 = require("./Selectors/PointSelector");

var PolylineSelector_1 = require("./Selectors/PolylineSelector");

var PolygonSelector_1 = require("./Selectors/PolygonSelector");

var RectCopySelector_1 = require("./Selectors/RectCopySelector");

var RectSelector_1 = require("./Selectors/RectSelector");
/**
 * The region selection manager.
 * @remarks The naming of the class is historical per the idea to specify the
 * region area to be selected. Thus AreaSelector.
 * @todo Consider renaming.
 */


var AreaSelector = /*#__PURE__*/function () {
  /**
   * Creates a new `AreaSelector` manager.
   * @param svgHost - The host SVG element.
   * @param callbacks - The collection of callbacks.
   */
  function AreaSelector(svgHost, callbacks) {
    _classCallCheck(this, AreaSelector);

    /**
     * Internal flag to track selector visibility.
     */
    this.isVisible = true;
    this.parentNode = svgHost;

    if (callbacks !== undefined) {
      this.callbacks = callbacks;
    } else {
      this.callbacks = {
        onLocked: null,
        onSelectionBegin: null,
        onSelectionEnd: null,
        onUnlocked: null
      };
    }

    this.buildUIElements();
  }
  /**
   * Resizes selectors to specified `width` and `height`.
   * @param width - The new `width` for selector.
   * @param height - The new `height` for selector.
   */


  _createClass(AreaSelector, [{
    key: "resize",
    value: function resize(width, height) {
      if (width !== undefined && height !== undefined) {
        this.boundRect.resize(width, height);
      } else {
        this.boundRect.resize(this.parentNode.width.baseVal.value, this.parentNode.height.baseVal.value);
      }

      if (this.selector !== null) {
        this.selector.resize(width, height);
      }
    }
    /**
     * Enables the current selector.
     */

  }, {
    key: "enable",
    value: function enable() {
      if (this.selector !== null) {
        this.selector.enable();
        this.selector.resize(this.boundRect.width, this.boundRect.height);
      }
    }
    /**
     * Disables the current selector.
     */

  }, {
    key: "disable",
    value: function disable() {
      if (this.selector !== null) {
        this.selector.disable();
      }
    }
    /**
     * Makes current selector visible and enabled.
     */

  }, {
    key: "show",
    value: function show() {
      this.enable();
      this.isVisible = true;
    }
    /**
     * Makes current selector hidden and disabled.
     */

  }, {
    key: "hide",
    value: function hide() {
      this.disable();
      this.isVisible = false;
    }
  }, {
    key: "setSelectionMode",
    value: function setSelectionMode(settings) {
      var selectionSettings;

      if (settings === null || settings === undefined) {
        selectionSettings = {
          mode: ISelectorSettings_1.SelectionMode.NONE
        };
      } else if (settings.mode !== undefined) {
        selectionSettings = settings;
      } else {
        selectionSettings = {
          mode: settings
        };
      }

      if (this.selectorSettings === undefined || this.selectorSettings.mode !== selectionSettings.mode) {
        this.disable();
        this.selectorSettings = selectionSettings;

        if (this.selectorSettings.mode === ISelectorSettings_1.SelectionMode.NONE || this.selectorSettings.mode === ISelectorSettings_1.SelectionMode.DRAG) {
          this.selector = null;
          return;
        } else if (this.selectorSettings.mode === ISelectorSettings_1.SelectionMode.COPYRECT) {
          this.selector = this.rectCopySelector;
          var template = this.selectorSettings.template;

          if (template !== undefined) {
            this.rectCopySelector.setTemplate(template);
          } else {
            this.rectCopySelector.setTemplate(AreaSelector.DefaultTemplateSize);
          }
        } else if (this.selectorSettings.mode === ISelectorSettings_1.SelectionMode.RECT) {
          this.selector = this.rectSelector;
        } else if (this.selectorSettings.mode === ISelectorSettings_1.SelectionMode.POINT) {
          this.selector = this.pointSelector;
        } else if (this.selectorSettings.mode === ISelectorSettings_1.SelectionMode.POLYLINE) {
          this.selector = this.polylineSelector;
        } else if (this.selectorSettings.mode === ISelectorSettings_1.SelectionMode.POLYGON) {
          this.selector = this.polygonSelector;
        } // restore enablement status


        this.enable();

        if (this.isVisible) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
    /**
     * Returns current options (settings) for selector.
     */

  }, {
    key: "getSelectorSettings",
    value: function getSelectorSettings() {
      return this.selectorSettings;
    }
    /**
     * Creates UI of the AreaSelector.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      this.paper = Snap(this.parentNode);
      this.boundRect = new Rect_1.Rect(this.parentNode.width.baseVal.value, this.parentNode.height.baseVal.value);
      this.areaSelectorLayer = this.paper.g();
      this.areaSelectorLayer.addClass("areaSelector");
      this.rectSelector = new RectSelector_1.RectSelector(this.parentNode, this.paper, this.boundRect, this.callbacks);
      this.rectCopySelector = new RectCopySelector_1.RectCopySelector(this.parentNode, this.paper, this.boundRect, new Rect_1.Rect(0, 0), this.callbacks);
      this.pointSelector = new PointSelector_1.PointSelector(this.parentNode, this.paper, this.boundRect, this.callbacks);
      this.polylineSelector = new PolylineSelector_1.PolylineSelector(this.parentNode, this.paper, this.boundRect, this.callbacks);
      this.polygonSelector = new PolygonSelector_1.PolygonSelector(this.parentNode, this.paper, this.boundRect, this.callbacks);
      this.selector = this.rectSelector;
      this.rectSelector.enable();
      this.rectCopySelector.disable();
      this.pointSelector.disable();
      this.polylineSelector.disable();
      this.polygonSelector.disable();
      this.selector.hide();
      this.areaSelectorLayer.add(this.rectSelector.node);
      this.areaSelectorLayer.add(this.rectCopySelector.node);
      this.areaSelectorLayer.add(this.pointSelector.node);
      this.areaSelectorLayer.add(this.polylineSelector.node);
      this.areaSelectorLayer.add(this.polygonSelector.node);
    }
  }]);

  return AreaSelector;
}();

exports.AreaSelector = AreaSelector;
/**
 * Default template size for the `RectCopySelector`.
 * @todo Move to the `RectCopySelector` class.
 */

AreaSelector.DefaultTemplateSize = new Rect_1.Rect(20, 20);